export default "__VITE_ASSET__ChHhd52H__"